import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as i } from "../chunks/tslib.es6.js";
import { isNone as s } from "../core/maybe.js";
import { after as e } from "../core/promiseUtils.js";
import { watch as o } from "../core/watchUtils.js";
import { aliasOf as t } from "../core/accessorSupport/decorators/aliasOf.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { property as r } from "../core/accessorSupport/decorators/property.js";
import { subclass as n } from "../core/accessorSupport/decorators/subclass.js";
import a from "./Widget.js";
import p from "./Spinner/SpinnerViewModel.js";
import "./support/widgetUtils.js";
import "../core/Logger.js";
import { tsx as l } from "./support/jsxFactory.js";
var c = {
  base: "esri-spinner",
  spinnerStart: "esri-spinner--start",
  spinnerFinish: "esri-spinner--finish"
};

var h = /*#__PURE__*/function (_a) {
  _inherits(h, _a);

  var _super = _createSuper(h);

  function h(i, s) {
    var _this;

    _classCallCheck(this, h);

    _this = _super.call(this, i, s), _this._animationDelay = 500, _this._animationPromise = null, _this.location = null, _this.view = null, _this.viewModel = new p(), _this.visible = !1;
    return _this;
  }

  _createClass(h, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.own([o(this, "visible", function (i) {
        return _this2._visibleChange(i);
      })]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._animationPromise = null;
    }
  }, {
    key: "show",
    value: function show(i) {
      var _this3 = this;

      var s = i.location,
          e = i.promise;
      s && (this.viewModel.location = s), this.visible = !0;

      var o = function o() {
        return _this3.hide();
      };

      e && e.catch(function () {}).then(o);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.visible = !1;
    }
  }, {
    key: "render",
    value: function render() {
      var _r;

      var i = this.visible,
          s = this.viewModel.screenLocation,
          e = !!s,
          o = i && e,
          t = !i && e,
          r = (_r = {}, _defineProperty(_r, c.spinnerStart, o), _defineProperty(_r, c.spinnerFinish, t), _r),
          n = this._getPositionStyles();

      return l("div", {
        class: this.classes(c.base, r),
        styles: n
      });
    }
  }, {
    key: "_visibleChange",
    value: function _visibleChange(i) {
      var _this4 = this;

      if (i) return void (this.viewModel.screenLocationEnabled = !0);
      var s = e(this._animationDelay);
      this._animationPromise = s, s.catch(function () {}).then(function () {
        _this4._animationPromise === s && (_this4.viewModel.screenLocationEnabled = !1, _this4._animationPromise = null);
      });
    }
  }, {
    key: "_getPositionStyles",
    value: function _getPositionStyles() {
      var _this$viewModel = this.viewModel,
          i = _this$viewModel.screenLocation,
          e = _this$viewModel.view;
      if (!e || s(i)) return {};
      var o = e.padding;
      return {
        left: i.x - o.left + "px",
        top: i.y - o.top + "px"
      };
    }
  }]);

  return h;
}(a);

i([t("viewModel.location")], h.prototype, "location", void 0), i([t("viewModel.view")], h.prototype, "view", void 0), i([r({
  type: p
})], h.prototype, "viewModel", void 0), i([t("viewModel.visible")], h.prototype, "visible", void 0), h = i([n("esri.widgets.Spinner")], h);
var m = h;
export { m as default };